import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import HitlReviewPanel from '../../llm/HitlReviewPanel';

/**
 * Diff-preview dialog for an NL edit's EDIT_PLAN checkpoint. The body is the shared
 * HitlReviewPanel (which renders the EditOps + binding diff for EDIT_PLAN), so approve /
 * answer go through the same HitlController surface as chat and reports.
 */
export default function EditDiffPreview({ open, checkpoint, jwtToken, onResolved, onClose }) {
  const { t } = useTranslation();
  if (!checkpoint) return null;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle>{t('Dashboards.diff.title')}</DialogTitle>
      <DialogContent dividers sx={{ p: { xs: 1, md: 2 }, minWidth: 0, overflowWrap: 'anywhere' }}>
        <HitlReviewPanel
          key={checkpoint.checkpointId}
          checkpoint={checkpoint}
          jwtToken={jwtToken}
          onResolved={onResolved}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('Dashboards.common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
